
import request from '@/utils/request'

//上传图片到oss
 export function uploadOss(data) {
return request({
  url: 'uploadOss',
		headers:{
			'Content-Type':'multipart/form-data',
		},
  method: 'post',
  data:data
})
}

 export function fileupload(data) {
return request({
  url: 'fileupload',
		headers:{
			'Content-Type':'multipart/form-data',
		},
  method: 'post',
  data:data
})
}

//上传初始模型库
 export function user_huanjing_shujuku(data) {
return request({
  url: 'user_huanjing_shujuku',
		headers:{
			'Content-Type':'multipart/form-data',
		},
  method: 'post',
  data:data
})
}



// WEBPACK FOOTER //
// ./src/api/config.js